import React from "react";
import { useIsMobile } from "../../Hooks/useIsMobile";
import "./style.css";

const SimpleBannerWrapper = ({ children }) => {
  const isMobile = useIsMobile();
 
  return (
    <>
      <div className="bg_blue mt-5">
        <div className="row mt-5">
          <div
            className={isMobile ? "col-md-12 p-0 text-center" : "col-md-12 p-0"}
          >
            <div
              class={isMobile ? "jumbotron" : "jumbotron pt-3 p-4 mt-5"}
              style={{ marginTop: `${isMobile ? "80px" : "0px"}` }}
            >
              <h3 class="text-white text-center font-weight-bold" style={{fontSize:'35px', fontWeight:'bold'}}>
              Which cover would you like to go for?
            
              </h3>
            </div>
          </div>
        </div>
      </div>
      {children}
    </>
  );
};

export default SimpleBannerWrapper;
